/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  /** Data de entrega do empreendimento de origem, no formato yyyy-MM-dd. */
  dataEntrega?: string | null;
  idEmpreendimento?: string | null;
  enabled?: boolean;
}

/**
 * Lista os blocos elegíveis do empreendimento selecionado.
 *
 * A data de entrega segue sendo enviada porque a regra de negócio exige que a
 * entrega do bloco destino seja igual à do empreendimento de origem.
 */
export function useGetBlocosCopiaProposta(props: Props) {
  const GET_BLOCOS = `${backofficeEnviroment}/common/oportunidades-lead/copia-proposta/blocos/v1`;

  const fetchData = async () => {
    const response = await instance.get(GET_BLOCOS, {
      params: {
        dataEntrega: props.dataEntrega,
        idEmpreendimento: props.idEmpreendimento,
      },
    });
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: [
      "copia-proposta-blocos",
      props.dataEntrega,
      props.idEmpreendimento,
    ],
    refetchOnWindowFocus: false,
    enabled: Boolean(
      props.enabled && props.dataEntrega && props.idEmpreendimento
    ),
    onError: (error: any) => {
      notificarErroApi("Erro ao buscar blocos", error);
    },
  });

  return query;
}
